import { CSSProperties } from 'react';
import ButtonSymphony from 'elements/ButtonSymphony';
import useScreen from 'Hooks/useScreen';
import Sty from 'modules/Sty';
import CardSymphony from 'elements/CardSymphony';

type OnboardingOptionCardProps = {
    imageSrc: string;
    title: string;
    description: string;
    buttonText: string;
    onClick: () => void;
};

const OnboardingOptionCard = ({
    imageSrc,
    title,
    description,
    buttonText,
    onClick,
}: OnboardingOptionCardProps) => {
    const { mStyle } = useScreen();
    return (
        <>
            <style>
                {`
                    .onboardingOptionCardComponent {
                        background-color: white;
                        transition: all 0.2s;
                        box-shadow: none;
                        &:hover {
                            background-color: #f6ebff;
                            transform: translateY(-5px);
                            box-shadow: 0px 6px 12px 0px rgba(0, 0, 0, 0.1);
                        }
                    }
                `}
            </style>
            <div
                className="onboardingOptionCardComponent"
                onClick={onClick}
                style={mStyle(sty, 'onboardingOptionCardComponent')}
            >
                <img
                    className="onboardingOptionCardImage"
                    style={{
                        width: '100%',
                        maxWidth: 90,
                    }}
                    src={imageSrc}
                    alt={title}
                />
                <CardSymphony
                    className="onboardingOptionCardCard"
                    title={title}
                    subtitle={description}
                    size="small"
                    isNoPadding
                    style={{ backgroundColor: 'transparent' }}
                />
                <ButtonSymphony
                    className="onboardingOptionCardButton"
                    style={{ flexShrink: 0, marginRight: 'auto', marginTop: 'auto' }}
                >
                    {buttonText}
                </ButtonSymphony>
            </div>
        </>
    );
};

const sty: Record<string, CSSProperties> = {
    onboardingOptionCardComponent: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        padding: 24,
        gap: 16,
        cursor: 'pointer',
        maxWidth: 300,
        border: Sty.border,
        borderRadius: 16,
    },
    onboardingOptionCardComponent_mobile: {
        maxWidth: 'auto',
    }
}

export default OnboardingOptionCard;
